<template>
  <Dialog v-model="show" title="Confirm" :yes-or-no="yesNo" :forceOption="forceOption" @ok="ok">
    <p>{{ msg }}</p>
  </Dialog>
</template>

<script setup lang="ts">
import Dialog from './Dialog.vue';
import { showConfirmationDialog, dialogMessage, yesNoConfirmation, dialogOk, forceOption } from '../utils';

const show = showConfirmationDialog;
const msg = dialogMessage;
const yesNo = yesNoConfirmation;

const ok = (yesOrNo?: boolean) => {
  dialogOk(yesOrNo);
};
</script>
